import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { IconButton } from '@chakra-ui/react'

const ButtonIcon = forwardRef(({ children, onClick, active, ...rest }, ref) => {
  return (
    <IconButton
      w={50}
      h={50}
      bg={!active ? 'white' : 'brand.textDarkBlue'}
      borderRadius="50%"
      onClick={onClick}
      boxShadow="lg"
      color={active ? 'white' : 'brand.textDarkBlue'}
      p={0}
      icon={children}
      _hover={{
        bg: !active ? 'brand.textBlue' : 'brand.textDarkBlue',
        color: 'white',
      }}
      _active={{ bg: 'brand.textBlue', color: 'white' }}
      ref={ref}
      {...rest}
    />
  )
})

ButtonIcon.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  active: PropTypes.bool,
}

export default ButtonIcon
